/**
 * @typedef {object} UserLevel
 *
 * @property {string} _id
 *
 * @property {string} code
 *
 * @property {string} name
 *
 * @property {number} rank
 *
 * @property {string[]} scope
 *
 * @property {object} chargeLimit
 *
 * @property {object} chargeLimit.today
 * @property {number} chargeLimit.today.priceMax
 *
 * @property {object} chargeLimit.month
 * @property {number} chargeLimit.month.priceMax
 *
 * @property {number} chargeCommission
 *
 * @property {object} exchangeLimit
 *
 * @property {object} exchangeLimit.today
 * @property {number} exchangeLimit.today.priceMax
 *
 * @property {object} exchangeLimit.month
 * @property {number} exchangeLimit.month.priceMax
 * @property {number} exchangeLimit.month.countMax
 *
 * @property {number} exchangeCommission
 */

/**
 * @param {UserLevel} data
 * @returns {UserLevel}
 */
export function initUserLevel(data) {
    data = {
        ...(data || {}),
        _id: data?._id || null,

        code: data?.code || null,
        name: data?.name || null,
        rank: data?.rank || null,

        scope: [...(data?.scope || [])],

        chargeLimit: {
            ...(data?.chargeLimit || {}),

            today: {
                ...(data?.chargeLimit?.today || {}),

                priceMax: data?.chargeLimit?.today?.priceMax || null,
            },

            month: {
                ...(data?.chargeLimit?.month || {}),

                priceMax: data?.chargeLimit?.month?.priceMax || null,
            },
        },

        chargeCommission: data?.chargeCommission || null,

        exchangeLimit: {
            ...(data?.exchangeLimit || {}),

            today: {
                ...(data?.exchangeLimit?.today || {}),

                priceMax: data?.exchangeLimit?.today?.priceMax || null,
            },

            month: {
                ...(data?.exchangeLimit?.month || {}),

                priceMax: data?.exchangeLimit?.month?.priceMax || null,
                countMax: data?.exchangeLimit?.month?.countMax || null,
            },
        },

        exchangeCommission: data?.exchangeCommission || null,
    };

    if (data._id === null) delete data._id;
    if (data.rank === null) delete data.rank;

    return data;
}
